import { render, staticRenderFns } from "./LeadTypeSelect.vue?vue&type=template&id=ca32bb40&"
import script from "./LeadTypeSelect.vue?vue&type=script&lang=js&"
export * from "./LeadTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports